import React from 'react';
import {
  numberToCurrencyString,
  numberToDisplayString,
} from 'further-ui/utils';
import { FooterRow, FooterCell } from 'components/Table';
import { FundAllocation } from '../index';
import {
  calculateCurrentTotals,
  calculatePreviousTotals,
} from '../shared/edited-calculation-utils';
import { Theme } from '@mui/material/styles';

type EditedTotalsProps = {
  fundIndex: number;
  originalFundAllocations: Array<FundAllocation>;
  watchedValues: { fundAllocations: Array<FundAllocation> };
  formFundAllocations: Array<FundAllocation>;
  isEditing: boolean;
  theme: Theme;
};

const EditedTotals: React.FC<EditedTotalsProps> = ({
  fundIndex,
  originalFundAllocations,
  watchedValues,
  formFundAllocations,
  isEditing,
  theme,
}) => {
  if (!isEditing) {
    return null;
  }

  const currentTotals = calculateCurrentTotals(
    fundIndex,
    watchedValues,
    formFundAllocations,
  );
  const previousTotals = calculatePreviousTotals(
    fundIndex,
    originalFundAllocations,
  );

  return (
    <>
      <FooterRow>
        <FooterCell style={{ textAlign: 'left' }}>Total</FooterCell>
        <FooterCell></FooterCell>
        <FooterCell style={{ paddingLeft: theme.spacing(4) }}>
          {numberToDisplayString(currentTotals.sharesAllocated)}
        </FooterCell>
        <FooterCell>
          {numberToCurrencyString(currentTotals.allocatedInvestment)}
        </FooterCell>
        <FooterCell style={{ paddingLeft: theme.spacing(4) }}>
          {numberToCurrencyString(currentTotals.adjustedInvestment)}
        </FooterCell>
        <FooterCell style={{ paddingLeft: theme.spacing(4) }}>
          {numberToCurrencyString(currentTotals.transactionFee)}
        </FooterCell>
        <FooterCell colSpan={2}></FooterCell>
        <FooterCell>
          {numberToCurrencyString(
            Math.max(currentTotals.postAllocationCapital, 0),
          )}
        </FooterCell>
        <FooterCell></FooterCell>
      </FooterRow>
      <FooterRow>
        <FooterCell style={{ fontWeight: 'normal', textAlign: 'left' }}>
          Previous total
        </FooterCell>
        <FooterCell></FooterCell>
        <FooterCell
          style={{
            fontWeight: 'normal',
            paddingLeft: theme.spacing(4),
          }}
        >
          {numberToDisplayString(previousTotals.sharesAllocated)}
        </FooterCell>
        <FooterCell style={{ fontWeight: 'normal' }}>
          {numberToCurrencyString(previousTotals.allocatedInvestment)}
        </FooterCell>
        <FooterCell
          style={{
            fontWeight: 'normal',
            paddingLeft: theme.spacing(4),
          }}
        >
          {numberToCurrencyString(previousTotals.adjustedInvestment)}
        </FooterCell>
        <FooterCell
          style={{
            fontWeight: 'normal',
            paddingLeft: theme.spacing(4),
          }}
        >
          {numberToCurrencyString(previousTotals.transactionFee)}
        </FooterCell>
        <FooterCell colSpan={2}></FooterCell>
        <FooterCell style={{ fontWeight: 'normal' }}>
          {numberToCurrencyString(
            Math.max(previousTotals.postAllocationCapital, 0),
          )}
        </FooterCell>
        <FooterCell></FooterCell>
      </FooterRow>
    </>
  );
};

export default EditedTotals;
